/**
 * Signature re-capture — link status callable (PF-6119).
 *
 * Called once on page load, before anything is shown, so a used or unknown link never presents a
 * phone form. The request and response shapes come from `@physiofit-digital/physiofit_types`.
 */
import type {
  GetSignatureRecaptureStatusRequest,
  GetSignatureRecaptureStatusResponse,
} from '@physiofit-digital/physiofit_types';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebaseConfig';

export const getSignatureRecaptureStatus = (data: GetSignatureRecaptureStatusRequest) =>
  httpsCallable<GetSignatureRecaptureStatusRequest, GetSignatureRecaptureStatusResponse>(
    functions,
    'getSignatureRecaptureStatus',
  )(data).then((r) => r.data);
